import styled, { css } from "styled-components";
import { ModuleLayoutStyle } from "../../../../services/playground";
export const ProductCardWrap = styled.a `
	display: flex;
	flex-direction: column;
	background-color: white;
	box-sizing: border-box;
	position: relative;
	transition: all 0.3s ease;
	text-decoration: none;

	${(props) => {
    if (typeof props.width === "number" || !isNaN(+props.width)) {
        return css `
				width: ${props.width}px;
			`;
    }
    return css `
			width: ${props.width || "291px"};
		`;
}}

	&:hover {
		border-color: #eaeaea;
		-webkit-box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
		box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
		text-decoration: none;

		& > .image:after {
			background-color: rgba(255, 255, 255, 0.1);
		}
	}
	.priceViewOrange {
		color: #ff5a00;
	}
	.priceViewTomato {
		color: #e53b2f;
	}
`;
export const ProductCardPoster = styled.section `
	width: 100%;
	position: relative;
	display: block;
	background: #fff;

	${(props) => {
    if (props.layoutStyle === ModuleLayoutStyle.Flower) {
        return "";
    }
    return css `
			padding-bottom: 100%;
		`;
}}

	&:after {
		content: "";
		display: block;
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		transition: all 0.3s ease;
	}
	.productFlowerImage {
		width: auto;
		height: 100%;
		display: block;
		margin: 0 auto;
	}

	.productImage {
		position: absolute;
		z-index: 0;
		left: 0;
		top: 0;
		display: block;
		width: 100%;
		height: 100%;
	}
`;
export const DescriptionWrap = styled.section `
	padding: 8px;
	display: flex;
	flex-direction: column;
	flex: 1 auto;

	html[dir="rtl"] & {
		& > p {
			direction: rtl;
		}
		& > div.currentPrice {
			text-align: right;
		}
	}

	& > .cardTitle {
		font-weight: normal;
		display: -webkit-box;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		color: #666;
		font-size: 14px;
		line-height: 18px;
		height: 36px;
		margin: 8px 0;
		flex: 1 auto;
	}

	& > div.currentPrice {
		font-size: 16px;
		color: #cb2127;
		font-weight: 800;
		font-family: Avenir-Heavy;
		line-height: 22px;
	}

	.suffix {
		height: 20px;
		margin-top: 6px;

		.originPrice {
			text-decoration: line-through;
			color: #999;
			font-size: 13px;
			font-weight: normal;
			line-height: 18px;
			float: left;
		}

		.leftView {
			font-size: 12px;
			font-family: Avenir-Medium;
			font-weight: 500;
			color: #666;
			line-height: 16px;
			float: left;
			margin-left: 15px;
		}
		.rightView {
			font-size: 14px;
			font-weight: normal;
			color: #666;
			float: right;
			display: flex;
			align-items: center;

			& > span {
				margin-left: 3px;
			}
		}

		html[dir="rtl"] & {
			.originPrice {
				float: right;
			}
			.rightView {
				float: left;
				direction: ltr;
			}
		}
	}
	.rightView > i,
	.likeIcon {
		display: inline-flex;
		width: 16px;
		height: 16px;
		background: url("https://i.ezbuy.sg/FnMkXCrG8u2d7PImYx0W5gh53i15") no-repeat;
		background-size: contain;

		&.mini {
			background-image: url("https://i.ezbuy.sg/FiWrA6OrjVlnuTHIWtff3bMaMnf8");
		}
	}

	${(props) => {
    const gridCol = props.gridCol;
    if (gridCol === 5) {
        return css `
				& > p {
					font-size: 12px;
					line-height: 16px;
					height: 32px;
				}

				& > div.currentPrice {
					font-size: 14px;
					color: #cb2127;
					line-height: 19px;
				}

				.suffix {
					.originPrice {
						font-size: 12px;
						line-height: 16px;
					}

					.leftView {
						font-size: 12px;
						line-height: 16px;
					}
					.rightView {
						font-size: 12px;

						& > img {
							height: 16px;
						}
					}
				}
			`;
    }
    return css ``;
}}
`;
export const LikeIcon = styled.i `
	display: inline-flex;
	width: 16px;
	height: 16px;
	background: url("https://i.ezbuy.sg/FnMkXCrG8u2d7PImYx0W5gh53i15") no-repeat;
	background-size: contain;

	&.mini {
		background-image: url("https://i.ezbuy.sg/FiWrA6OrjVlnuTHIWtff3bMaMnf8");
	}
`;
